import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { UserState } from "../../types/types";
import NoItems from "../alerts/NoItems";
import { Navigate, Outlet } from "react-router";
import { ROLES_ID } from "../../utils/roles";
import { Stack } from "@mui/material";

type Props = {
  allowedTo: number[];
  children: ReactNode;
};
// export const ROLES_ID = {
//   SUPER_ADMIN: 1,
//   ADMIN: 2,
//   USER: 3,
//   MARKETER: 4,
// };

const AllowedTo = ({ allowedTo, children }: Props) => {
  const userData = useSelector((state: UserState) => state.user.userData);
  const userRoles: number[] = userData.roles;

  const isAllowed =
    allowedTo.includes(0) || userRoles.some((role) => allowedTo.includes(role));

  return isAllowed ? (
    <>{children}</>
  ) : userRoles.includes(ROLES_ID.ADMIN) ? (
    <Navigate to="/" />
  ) : userRoles.includes(ROLES_ID.MARKETER) ? (
    <Navigate to="/marketer" />
  ) : (
    <Stack>NOT allowed</Stack>
  );
};

export default AllowedTo;
